export var LifeCycleEventType;
(function (LifeCycleEventType) {
    LifeCycleEventType[LifeCycleEventType["ERROR_COLLECTED"] = 0] = "ERROR_COLLECTED";
    LifeCycleEventType[LifeCycleEventType["PERFORMANCE_ENTRY_COLLECTED"] = 1] = "PERFORMANCE_ENTRY_COLLECTED";
    LifeCycleEventType[LifeCycleEventType["USER_ACTION_COLLECTED"] = 2] = "USER_ACTION_COLLECTED";
    LifeCycleEventType[LifeCycleEventType["VIEW_COLLECTED"] = 3] = "VIEW_COLLECTED";
    LifeCycleEventType[LifeCycleEventType["REQUEST_STARTED"] = 4] = "REQUEST_STARTED";
    LifeCycleEventType[LifeCycleEventType["REQUEST_COMPLETED"] = 5] = "REQUEST_COMPLETED";
    LifeCycleEventType[LifeCycleEventType["SESSION_RENEWED"] = 6] = "SESSION_RENEWED";
    LifeCycleEventType[LifeCycleEventType["RESOURCE_ADDED_TO_BATCH"] = 7] = "RESOURCE_ADDED_TO_BATCH";
    LifeCycleEventType[LifeCycleEventType["DOM_MUTATED"] = 8] = "DOM_MUTATED";
    LifeCycleEventType[LifeCycleEventType["BEFORE_UNLOAD"] = 9] = "BEFORE_UNLOAD";
})(LifeCycleEventType || (LifeCycleEventType = {}));
var LifeCycle = /** @class */ (function () {
    function LifeCycle() {
        this.callbacks = {};
    }
    LifeCycle.prototype.notify = function (eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) {
            eventCallbacks.forEach(function (callback) { return callback(data); });
        }
    };
    LifeCycle.prototype.subscribe = function (eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) {
            this.callbacks[eventType] = [];
        }
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function () {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) { return callback !== other; });
            },
        };
    };
    return LifeCycle;
}());
export { LifeCycle };
//# sourceMappingURL=lifeCycle.js.map